(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-footer"] && !Shopify.designMode) return;
  try {
    
    (function () {
  document.querySelectorAll('[data-custom-footer]').forEach(function(root) {
  if (root.dataset.footerInitialized === 'true') return;
  root.dataset.footerInitialized = 'true';

  const enableAccordion = root.dataset.accordionEnabled === 'true';
  const defaultOpen = parseInt(root.dataset.defaultOpen, 10);
      const breakpoint = 989;

      const cols = Array.from(root.querySelectorAll('details.cf5__col'));

      function isMobile() {
        return window.innerWidth <= breakpoint;
      }

      function applyState() {
        if (!isMobile()) {
          // Desktop: always open
          cols.forEach(d => d.open = true);
          return;
        }

        // Mobile
        if (!enableAccordion) {
          cols.forEach(d => d.open = true);
          return;
        }

        cols.forEach(d => d.open = false);

        if (defaultOpen >= 1 && defaultOpen <= 5) {
          const match = root.querySelector('details.cf5__col[data-col="' + defaultOpen + '"]');
          if (match) match.open = true;
        }
      }

      // Only allow one open at a time on mobile when accordion enabled
      cols.forEach(d => {
        d.addEventListener('toggle', () => {
          if (!enableAccordion) return;
          if (!isMobile()) return;
          if (!d.open) return;
          cols.forEach(other => {
            if (other !== d) other.open = false;
          });
        });
      });

      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(applyState, 120);
      });

         applyState();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buying-guide-article"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.buying-guide').forEach((guide) => {
  const content = guide.querySelector('.buying-guide__content');
  const headings = [...content.querySelectorAll('h2')];
  const tocTargets = guide.querySelectorAll('.buying-guide__toc');

  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `guide-section-${index + 1}`;
  });

  tocTargets.forEach((toc) => {
    headings.forEach((heading) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      toc.appendChild(link);
    });
  });

  if (!headings.length) {
    guide.querySelectorAll('.buying-guide__contents, .buying-guide__mobile-contents').forEach((element) => element.remove());
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.guide-page').forEach((guide) => {
  const content = guide.querySelector('.guide-page__content');
  const headings = [...content.querySelectorAll('h2')];
  const tocTargets = guide.querySelectorAll('.guide-page__toc');

  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `page-guide-section-${index + 1}`;
  });

  tocTargets.forEach((toc) => {
    headings.forEach((heading) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      toc.appendChild(link);
    });
  });

  if (!headings.length) {
    guide.querySelectorAll('.guide-page__contents, .guide-page__mobile-contents').forEach((element) => element.remove());
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hopshop-slim-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-promo-carousel]').forEach(function(root) {
  if (root.dataset.promoInitialized === 'true') return;
  root.dataset.promoInitialized = 'true';

  const track = root.querySelector('[data-promo-track]');
  const slides = Array.from(root.querySelectorAll('.hopshop-promo__slide'));
  const prevBtns = Array.from(root.querySelectorAll('[data-promo-prev]'));
  const nextBtns = Array.from(root.querySelectorAll('[data-promo-next]'));

  if (!track || slides.length <= 1) return;

  let index = 0;
  let timer = null;
  let startX = 0;
  let endX = 0;

  const autoplay = root.dataset.autoplay === 'true';
const delay = Number(root.dataset.delay);
const pauseAfterInteraction = Number(root.dataset.resumeDelay);

  function updateSlider(newIndex) {
    index = (newIndex + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
  }

  function nextSlide() {
    updateSlider(index + 1);
  }

  function prevSlide() {
    updateSlider(index - 1);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    timer = setInterval(nextSlide, delay);
  }

  function restartAutoplayLater() {
    stopAutoplay();
    setTimeout(startAutoplay, pauseAfterInteraction);
  }

  nextBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      nextSlide();
      restartAutoplayLater();
    });
  });

  prevBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      prevSlide();
      restartAutoplayLater();
    });
  });

  root.addEventListener('touchstart', function(e) {
    startX = e.changedTouches[0].clientX;
  }, { passive: true });

  root.addEventListener('touchend', function(e) {
    endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    if (Math.abs(diff) > 40) {
      if (diff > 0) nextSlide();
      else prevSlide();
      restartAutoplayLater();
    }
  }, { passive: true });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) stopAutoplay();
    else startAutoplay();
  });

  updateSlider(0);
  startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.recipe-article').forEach((recipe) => {
    const content = recipe.querySelector('[data-recipe-content]');

    if (!content || recipe.dataset.enhanced === 'true') return;

    recipe.dataset.enhanced = 'true';

    const headings = [...content.querySelectorAll('h2')];
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id =
        heading.id ||
        heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');

      if (!id) {
        id = `recipe-section-${index + 1}`;
      }

      let uniqueId = id;
      let suffix = 2;

      while (usedIds.has(uniqueId)) {
        uniqueId = `${id}-${suffix++}`;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;
    });

    recipe.querySelectorAll('.recipe-article__toc').forEach((toc) => {
      headings.forEach((heading) => {
        const link = document.createElement('a');

        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();

        toc.appendChild(link);
      });
    });

    if (!headings.length) {
      recipe
        .querySelectorAll(
          '.recipe-article__contents, .recipe-article__mobile-nav'
        )
        .forEach((element) => element.remove());
    }

    headings.forEach((heading) => {
      const title = heading.textContent.trim().toLowerCase();
      const next = heading.nextElementSibling;

      if (
        title.includes('equipment') &&
        next &&
        (next.matches('ul') || next.matches('ol'))
      ) {
        next.classList.add('recipe-panel');
      }

      const stepHeading =
        title.includes('preparing') ||
        title.includes('making') ||
        title.includes('fermentation') ||
        title.includes('transfer') ||
        title.includes('racking') ||
        title.includes('bottling');

      if (stepHeading && next && next.matches('ol')) {
        next.classList.add('recipe-steps');
      }
    });

    const printButton = recipe.querySelector('[data-recipe-print]');

printButton?.addEventListener('click', () => {
  const recipeTitle =
    recipe.querySelector('.recipe-article__header h1')?.textContent.trim() ||
    'Home Brew Recipe';

  const recipeHeader = recipe.querySelector(
    '.recipe-article__header'
  )?.cloneNode(true);

  const recipeQuick = recipe.querySelector(
    '.recipe-article__quick'
  )?.cloneNode(true);

  const recipeFacts = recipe.querySelector(
    '.recipe-article__facts'
  )?.cloneNode(true);

  const recipeContent = recipe.querySelector(
    '.recipe-article__content'
  )?.cloneNode(true);
if (!recipeContent) return;

/*
 * Start the printable article at Recipe overview.
 * Remove everything before that heading.
 */
const overviewHeading = [...recipeContent.querySelectorAll('h2, h3')].find(
  (heading) =>
    heading.textContent.trim().toLowerCase() === 'recipe overview'
);

if (overviewHeading) {
  let element = recipeContent.firstElementChild;

  while (element && element !== overviewHeading) {
    const nextElement = element.nextElementSibling;
    element.remove();
    element = nextElement;
  }
}

recipeContent
  .querySelectorAll(
    [
      '.recipe-product-grid',
      '.recipe-products',
      '[class*="shop-the-"]',
      '[class*="product-grid"]',
      '[class*="product-card"]',
      '[data-product-grid]',
      '[data-product-card]',
      '.recipe-article__shop-card',
      '.recipe-article__related',
      '.recipe-article__contents',
      '.recipe-article__mobile-nav',
      '.recipe-article__sidebar'
    ].join(',')
  )
  .forEach((element) => element.remove());

/*
 * Remove sections headed “Shop the ingredients” or “Shop the equipment”.
 */
recipeContent.querySelectorAll('h2, h3').forEach((heading) => {
  const title = heading.textContent.trim().toLowerCase();

  if (
    title === 'shop the ingredients' ||
    title === 'shop the equipment'
  ) {
    const wrapper = heading.parentElement;

    if (
      wrapper &&
      wrapper !== recipeContent &&
      wrapper.children.length > 1
    ) {
      wrapper.remove();
    } else {
      heading.remove();
    }
  }
});

/*
 * Remove non-essential article images.
 * The featured recipe image is added separately above.
 */
recipeContent.querySelectorAll('img, picture, svg, video, iframe').forEach(
  (element) => element.remove()
);

/*
 * Remove all storefront classes, IDs and inline layout attributes.
 */
recipeContent.querySelectorAll('*').forEach((element) => {
  element.removeAttribute('class');
  element.removeAttribute('id');
  element.removeAttribute('style');
  element.removeAttribute('width');
  element.removeAttribute('height');
  element.removeAttribute('hidden');

  [...element.attributes].forEach((attribute) => {
    if (
      attribute.name.startsWith('data-') ||
      attribute.name.startsWith('aria-')
    ) {
      element.removeAttribute(attribute.name);
    }
  });
});

/*
 * Flatten layout-only wrappers so they cannot reserve whole printed pages.
 */
recipeContent
  .querySelectorAll('div, section, article, aside, nav')
  .forEach((wrapper) => {
    wrapper.replaceWith(...wrapper.childNodes);
  });

recipeHeader
  ?.querySelectorAll('.recipe-article__print')
  .forEach((button) => button.remove());

  const printWindow = window.open(
    '',
    '_blank',
    'width=1000,height=800'
  );

  if (!printWindow) return;

  printWindow.document.open();

  printWindow.document.write(`
    <!doctype html>
    <html lang="en">
      <head>
        <meta charset="utf-8">

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        >

        <title>${recipeTitle}</title>

        <style>
          @page {
            size: A4;
            margin: 12mm;
          }

          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
          }

          body {
            color: #273025;
            background: #fff;
            font-family: Arial, Helvetica, sans-serif;
            font-size: 10.5pt;
            line-height: 1.45;
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }

          .print-recipe {
            width: 100%;
            max-width: 186mm;
            margin: 0 auto;
          }

          .recipe-article__header {
            margin: 0 0 12px;
          }

          .recipe-article__eyebrow {
            margin: 0 0 4px;
            color: #266e26;
            font-size: 9pt;
            font-weight: 700;
          }

          h1 {
            margin: 0 0 6px;
            color: #46523e;
            font-size: 23pt;
            line-height: 1.12;
          }

          h2 {
            margin: 16px 0 7px;
            color: #46523e;
            font-size: 16pt;
            line-height: 1.25;
            break-after: auto;
            page-break-after: auto;
          }

          h3 {
            margin: 14px 0 6px;
            color: #46523e;
            font-size: 12.5pt;
            line-height: 1.3;
            break-after: avoid;
            page-break-after: avoid;
          }

          h4,
          h5,
          h6 {
            color: #46523e;
            break-after: avoid;
            page-break-after: avoid;
          }

          p {
  margin: 0 0 8px;
  break-inside: avoid;
  page-break-inside: avoid;
  orphans: 3;
  widows: 3;
}

          ul,
          ol {
            margin: 0 0 12px;
            padding-left: 20px;
            orphans: 3;
            widows: 3;
          }

          li {
            margin-bottom: 4px;
          }

          a {
            color: inherit;
            text-decoration: none;
          }

          .recipe-article__meta {
            display: flex;
            align-items: center;
            gap: 10px;
            color: #46523e;
            font-size: 9pt;
          }

          .recipe-article__hero {
            margin: 0 0 12px;
            break-inside: auto;
            page-break-inside: auto;
          }

          .recipe-article__hero img {
            display: block;
            width: 100%;
            max-height: 78mm;
            object-fit: cover;
            border-radius: 5px;
          }

          .recipe-article__quick {
            margin: 0 0 14px;
            padding: 10px 12px;
            border: 1px solid #d9e2d2;
            border-left: 4px solid #266e26;
            background: #f3f7f1;
            break-inside: avoid;
            page-break-inside: avoid;
          }

          .recipe-article__quick h2 {
            margin: 0 0 5px;
            font-size: 13pt;
          }

          .recipe-article__quick p:last-child {
            margin-bottom: 0;
          }

          .recipe-article__facts {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 4px;
            margin: 0 0 16px;
          }

          .recipe-article__facts > div {
            padding: 7px;
            border: 1px solid #d9e2d2;
            background: #f3f7f1;
            break-inside: avoid;
            page-break-inside: avoid;
          }

          .recipe-article__facts dt {
            font-size: 7.5pt;
            font-weight: 700;
          }

          .recipe-article__facts dd {
            margin: 2px 0 0;
            font-size: 9.5pt;
            font-weight: 700;
          }

          .recipe-article__content {
            display: block;
          }

          .recipe-article__content > * {
            break-inside: auto;
            page-break-inside: auto;
          }

          .recipe-article__content img {
            display: block;
            max-width: 100%;
            max-height: 95mm;
            height: auto;
            margin: 8px auto;
            object-fit: contain;
          }

          .recipe-article__content table {
            width: 100%;
            margin: 0 0 14px;
            border-collapse: collapse;
          }

          .recipe-article__content th,
          .recipe-article__content td {
            padding: 6px;
            border: 1px solid #cfd8ca;
            text-align: left;
            vertical-align: top;
          }

          .recipe-article__content th {
            background: #f3f7f1;
          }

          .recipe-panel {
            margin: 0 0 12px;
            padding: 10px 12px;
            border: 1px solid #d9e2d2;
            border-left: 4px solid #266e26;
            background: #f3f7f1;
            break-inside: avoid;
            page-break-inside: avoid;
          }

          .recipe-steps {
            display: block;
            padding-left: 20px;
          }

          .recipe-steps > li {
            margin-bottom: 8px;
            break-inside: avoid;
            page-break-inside: avoid;
          }

          .recipe-product-grid,
          .recipe-products,
          [class*="shop-the-"],
          [class*="product-grid"],
          [class*="product-card"],
          [data-product-grid],
          [data-product-card],
          .recipe-article__shop-card,
          .recipe-article__related,
          .recipe-article__contents,
          .recipe-article__mobile-nav,
          .recipe-article__sidebar,
          .recipe-article__print {
            display: none !important;
          }

          @media print {
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
          }
        

.recipe-article__content h2 {
  margin: 14px 0 6px !important;
  break-before: auto !important;
  break-after: auto !important;
  page-break-before: auto !important;
  page-break-after: auto !important;
}

.recipe-article__content h2 + p,
.recipe-article__content h3 + p {
  break-before: avoid-page !important;
  page-break-before: avoid !important;
}

.recipe-article__hero {
  margin-bottom: 10px !important;
}

.recipe-article__hero img {
  max-height: 72mm !important;
}
        </style>
      </head>

      <body>
        <main class="print-recipe">
          ${recipeHeader ? recipeHeader.outerHTML : ''}
          ${recipeQuick ? recipeQuick.outerHTML : ''}
          ${recipeFacts ? recipeFacts.outerHTML : ''}
          ${recipeContent.outerHTML}
        </main>

        <script>
          window.addEventListener('load', () => {
            const images = [...document.images];

            Promise.all(
              images.map((image) => {
                if (image.complete) {
                  return Promise.resolve();
                }

                return new Promise((resolve) => {
                  image.addEventListener(
                    'load',
                    resolve,
                    { once: true }
                  );

                  image.addEventListener(
                    'error',
                    resolve,
                    { once: true }
                  );
                });
              })
            ).then(() => {
              window.focus();
              window.print();
            });
          });

          window.addEventListener('afterprint', () => {
            window.close();
          });
        <\/script>
      </body>
    </html>
  `);

  printWindow.document.close();
});

    const ingredientTable = content.querySelector('table');
    const stepItems = [
      ...content.querySelectorAll('ol.recipe-steps > li')
    ];

    if (
      ingredientTable &&
      stepItems.length &&
      !document.querySelector('[data-generated-recipe-schema]')
    ) {
      const ingredientRows = [
        ...ingredientTable.querySelectorAll('tbody tr')
      ];

      const ingredients = ingredientRows
        .map((row) =>
          [...row.querySelectorAll('th, td')]
            .map((cell) => cell.textContent.trim())
            .join(' — ')
        )
        .filter(Boolean);

      const schema = {
        '@context': 'https://schema.org',
        '@type': 'Recipe',
        name: recipe.querySelector('h1')?.textContent.trim(),
        description: recipe
          .querySelector('.recipe-article__quick div')
          ?.textContent.trim(),
        image: recipe.querySelector('.recipe-article__hero img')?.currentSrc,
        recipeIngredient: ingredients,
        recipeInstructions: stepItems.map((item, index) => ({
          '@type': 'HowToStep',
          position: index + 1,
          text: item.textContent.trim()
        }))
      };

      Object.keys(schema).forEach((key) => {
        if (
          !schema[key] ||
          (Array.isArray(schema[key]) && !schema[key].length)
        ) {
          delete schema[key];
        }
      });

      const script = document.createElement('script');

      script.type = 'application/ld+json';
      script.dataset.generatedRecipeSchema = 'true';
      script.textContent = JSON.stringify(schema);

      document.head.appendChild(script);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
